import {createRoot, hydrateRoot} from 'react-dom/client';
import Infrastructure from '../pages/Infrastructure/Infrastructure'
import "../index.css";
import "../pages/Infrastructure/Infrastructure.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<Infrastructure {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <Infrastructure {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).InfrastructureVC = {mount, hydrate, unmount}